import React from 'react'
import { HowItWorksWrapper } from '../affiliate/styles'
import { Header2, Text } from '../../styles/Components'
import Button from '../Button'
import { gsColors } from '../../styles/Variables'

const BrandActivations = ({ handleClick }) => {
  const data = {
    'On-site glam suites':
      'Upcoming conference? Bring a team of beauty pros on-site to provide glam services for hosts, speakers, influencers, and execs.',
    'Private VIP Appointments':
      'A luxe touch. Coordinate pre-event glam sessions for VIP clients or guests— right from the comfort of their homes or hotel suites.',
    'Event pop-ups':
      'Ensure an unforgettable event with glam stations offering hair and makeup touch-ups.',
  }
  return (
    <HowItWorksWrapper>
      <div className="how-content">
        <Header2 align="center">Seamless Brand Activations</Header2>
        <div className="items-container">
          {Object.keys(data).map((item, i) => (
            <div className="item" key={i}>
              <Text weight={700} fontSize={22}>
                {item}
              </Text>
              <Text weight={400} fontSize={22}>
                {data[item]}
              </Text>
            </div>
          ))}
        </div>
        <Text
          className="get-in-touch-text"
          textAlign="center"
          lineHeight="138%"
          spacing={0.96}
          margin="46px 0 50px"
        >
          Want more ideas? Give us some details and we&apos;ll brainstorm.
        </Text>
        <div className="get-in-touch-button">
          <Button
            large
            outline
            color={gsColors.black}
            align="center"
            onClick={handleClick}
          >
            Get In Touch
          </Button>
        </div>
      </div>
    </HowItWorksWrapper>
  )
}

export default BrandActivations
